import { Provider } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { LocaleService } from '@cmi/addin-core';
import { App } from './app/app';
import { appConfig } from './app/app.config';

// Set by the `standalone` build configuration in angular.json.
// eslint-disable-next-line @typescript-eslint/naming-convention
declare const __STANDALONE__: boolean;

/** Resolves with the providers that stand in for what only Office has. */
function boot(): Promise<Provider[]> {
  const replaceState = window.history.replaceState.bind(window.history);
  const pushState = window.history.pushState.bind(window.history);

  // Standalone dev mode: no office.js, so nothing patches history either, and
  // no Outlook to sign in to Graph through. The dynamic imports keep the mock
  // and the Graph fake out of every other build.
  if (__STANDALONE__) {
    return Promise.all([import('@cmi/office-mock'), import('./app/home/graph/graph-fake')]).then(
      ([{ installOfficeMock }, { provideGraphFake }]): Provider[] => {
        installOfficeMock('Outlook');
        return provideGraphFake();
      }
    );
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js';

    script.onload = (): void => {
      void Office.onReady(({ host }): void => {
        window.history.replaceState = replaceState;
        window.history.pushState = pushState;

        if (host) {
          resolve([]);
        } else {
          reject(new Error('The application has to run from within Office'));
        }
      });
    };

    document.body.appendChild(script);
  });
}

void boot().then(async (providers): Promise<void> => {
  const appRef = await bootstrapApplication(App, {
    providers: [...appConfig.providers, ...providers]
  });
  const localeService = appRef.injector.get(LocaleService);
  await localeService.loadTranslations();
});
